export default __webpack_public_path__ + "static/media/EM0440.34I-22012_-14995_0.4429c2a6.jpg";